<template>
  <FormContainer without-divider>
    <template #title>Prestation</template>
    <template #content>
      <div class="form__bloc">
          <WrapperDropdown
            id="field_sousDispositif"
            v-model="sousDispositifModel"
            label="Type de badges/cartes"
            :required="meta.sousDispositif?.$status === PropertyStatus.Required"
            :alertLabel="meta.sousDispositif?.$messageErreurDirty!"
            class="col-18 col-md-18 col-sm-36"
            :items="lov.SousDispositif"
            key-id="code"
            key-label="intitule"
            :readonly
            disabled
          />
          <WrapperInput
            id="field_ReferenceInterneEntreprise"
            v-model="referenceFormationInterneEntrepriseModel"
            label="Référence interne de l'entreprise"
            :required="meta.prestation?.referenceFormationInterneEntreprise?.$status === PropertyStatus.Required"
            :alertLabel="meta.prestation?.referenceFormationInterneEntreprise?.$messageErreurDirty!"
            class="col-8 col-md-12 col-sm-36"
            hint="30 caractères maximum"
            help="Ce champ vous permet de renseigner une référence propre à votre entreprise"
            :maxlength="30"
            deletable
            :readonly
          />
      </div>
    </template>
  </FormContainer>
</template>

<script setup lang="ts">

  import { PropertyStatus } from '@/features/domaine/property-status'
import { FormContainer } from '@/features/interface/demande/shared'
import { storeToRefs } from 'pinia'
import { useDemandeOutilFPEStore } from '../../../../useDemandeOutilFPEStore.ts'
  const store = useDemandeOutilFPEStore()

  const {  readonly, meta, lov } = storeToRefs(store)
  const { setupFieldWithKey } = store

  const sousDispositifModel = setupFieldWithKey<string>('sousDispositif', true)

  const referenceFormationInterneEntrepriseModel = setupFieldWithKey<string>(
    'prestation.referenceFormationInterneEntreprise',
    true,
  )
</script>

